export default __webpack_public_path__ + "static/media/hj2.c7004bfc.jpg";